module.exports = __webpack_public_path__ + "img/cxample_11.337aa25c.png";